<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  page: {
    title: "Soal Menjodohkan",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Soal", name: "-" },
      { width: "100px", label: "Versi Soal", name: "-" },
      { width: "100px", label: "Tipe", name: "-" },
      { width: "auto", label: "Gambar", name: "-" },
      { width: "auto", label: "Pertanyaan", name: "pertanyaan" },
      { width: "200px", label: "Jumlah Jawaban", name: "-" },
      { width: "160px", label: "Status Review", name: "-" },
      { width: "250px", label: "Catatan Review", name: "-" },
      { width: "260px", label: "Aksi", name: "-" },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Soal Menjodohkan",
      items: [
        {
          text: "Master Soal",
          href: "/",
        },
        {
          text: "Soal Menjodohkan",
          active: true,
        },
      ],
      link: process.env.VUE_APP_BACKEND_URL,
      isLoading: true,
      table_data: [],
      columns: columns,
      sortKey: "kompetensi_idkompetensi",
      sortOrders: sortOrders,

      currentTablePage: "",
      tableFilter: {
        status: 1,
        status_review: "",
        search: "",
        page: 1,
        per_page: 10,
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      idKompetensi: this.$route.params.id,
      kompetensi: {},
      dataPreview: {},
      modalPreview: false,
      showModalPreview: false,
      previewUrl: "",
      showModalOriginal: false,
      soalOriginal: null,
      soalOriginalKunciJawaban: "",
      isLoadingSoalOriginal: false,
      reopenSoalOriginalAfterPreview: false,
      isWriteSetup: localStorage.getItem("isWrite"),
      isReadSetup: localStorage.getItem("isRead"),
      canKirimHasilPerbaikan: false,
      kompetensiStatusReview: "",
    };
  },
  watch: {
    showModalPreview(val) {
      if (!val && this.reopenSoalOriginalAfterPreview) {
        this.reopenSoalOriginalAfterPreview = false;
        this.showModalOriginal = true;
      }
    },
  },
  updated() {
    $("div.pilihan-jawaban > img").addClass("image");
    console.log("updated");
  },
  mounted() {
    this.getKompetensi();
    if (!(this.isWriteSetup || this.isWriteSetup == 1)) {
      this.columns.pop();
    }
    this.getData(
      process.env.VUE_APP_BACKEND_URL_VERSION +
        "monitoring-review/tools-asesmen/kompetensi/" +
        this.idKompetensi +
        "/soal-jodoh"
    );
    this.checkCanKirimHasilPerbaikan();
  },
  methods: {
    async checkCanKirimHasilPerbaikan() {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "monitoring-review/tools-asesmen/kompetensi/" +
            this.idKompetensi +
            "/can-kirim-perbaikan",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });

      if (data) {
        this.canKirimHasilPerbaikan = data.canSend === true;
        this.kompetensiStatusReview = data.status_review || "PENDING";
      }
    },
    async kirimHasilPerbaikan() {
      Swal.fire({
        title: "Mohon tunggu",
        text: "Mengecek apakah masih ada soal yang berstatus REVIEWED pada kompetensi ini...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const data = await axios
        .post(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "monitoring-review/tools-asesmen/kompetensi/" +
            this.idKompetensi +
            "/kirim-hasil-perbaikan",
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: "Gagal mengirim hasil perbaikan.",
          });
          return false;
        });

      if (data) {
        if (data.updated) {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Hasil perbaikan berhasil dikirim.",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            this.$router.push({ name: "monitoring-review-tools-asesmen" });
          });
        } else {
          Swal.fire({
            icon: "info",
            title: "Tidak Ada Perubahan",
            text: data.message || "Tidak ada hasil perbaikan yang perlu dikirim.",
          });
        }
      }
    },
    async getKompetensi() {
      console.log(this.$route.params.id);
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kompetensi/" +
            this.idKompetensi,
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data);

      if (data) {
        this.kompetensi = data;
      }
    },
    async getData(url = "", resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page; // Reset to first page when fetching new data
      this.isLoading = true;
      if (url == "") {
        url =
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "monitoring-review/tools-asesmen/kompetensi/" +
          this.idKompetensi +
          "/soal-jodoh";
      }

      const data = await axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
            Accept: "Application/json",
          },
          params: this.tableFilter,
        })
        .then((response) => {
          let responseData = response.data;

          this.pagination.lastPage = responseData.data.last_page;
          this.pagination.currentPage = responseData.data.current_page;
          this.pagination.total = responseData.data.total;
          this.pagination.lastPageUrl = responseData.data.last_page_url;
          this.pagination.nextPageUrl = responseData.data.next_page_url;
          this.pagination.prevPageUrl = responseData.data.prev_page_url;
          this.pagination.from = responseData.data.from;
          this.pagination.to = responseData.data.to;
          this.pagination.links = responseData.data.links;
          this.currentTablePage = responseData.data.current_page;

          return responseData.data.data;
        })
        .catch((err) => {
          let errResponse = err.response.data;
          if (errResponse.meta.code == 403) {
            Swal.fire({
              icon: "error",
              title: "Terjadi Kesalahan",
              text: errResponse.meta.message,
            });
            this.$router.push({ name: "logout" });
            return false;
          }
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: errResponse.data,
          });

          console.log(errResponse);
          return false;
        });

      if (data) {
        this.table_data = data;
        await this.getReviewStatuses();
      }
      this.isLoading = false;
    },
    async getReviewStatuses() {
      const idsoal = this.table_data.map((row) => row.idsoal).filter(Boolean);
      if (!idsoal.length) return;

      const data = await axios
        .post(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "review-soal/tools-asesmen/soal/status",
          { idsoal },
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });

      if (data) {
        this.table_data.forEach((row) => {
          const review = data[row.idsoal];
          row.status_review = review?.status_review ?? "PENDING";
          row.catatan_review = review?.catatan_review ?? "";
        });
      }
    },
    statusReviewBadgeClass(status) {
      switch (status) {
        case "COMPLETED":
          return "bg-success";
        case "REVISION":
          return "bg-danger";
        case "REPAIRED":
          return "bg-primary";
        case "REVIEWED":
          return "bg-info";
        case "PENDING":
          return "bg-secondary";
        default:
          return "bg-secondary";
      }
    },
    statusReviewIcon(status) {
      switch (status) {
        case "COMPLETED":
          return "fa fa-check-circle";
        case "REVISION":
          return "fa fa-pen";
        case "REPAIRED":
          return "fa fa-wrench";
        case "REVIEWED":
          return "fa fa-eye";
        default:
          return "fa fa-clock";
      }
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getData("", false);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getData();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    async preview(row) {
      Swal.fire({
        icon: "warning",
        title: "Mohon tunggu",
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kompetensi/" +
            this.idKompetensi +
            "/soal/" +
            row.idsoal,
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        )
        .then((response) => response.data.data);
      if (data) {
        this.dataPreview = data;
      }
      Swal.close();
      this.modalPreview = true;
    },
    async showSoalOriginal(row) {
      this.soalOriginal = null;
      this.isLoadingSoalOriginal = true;
      this.showModalOriginal = true;

      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "monitoring-review/tools-asesmen/soal/" +
            row.idsoal +
            "/original",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });

      this.isLoadingSoalOriginal = false;

      if (data) {
        this.soalOriginal = data;
        const kunci = (data.jawaban || []).find((j) => j.skor);
        this.soalOriginalKunciJawaban = kunci ? kunci.kode_jawaban : "";
      }
    },
    previewOriginalImage() {
      this.reopenSoalOriginalAfterPreview = true;
      this.showModalOriginal = false;
      this.previewUrl = this.link + this.soalOriginal.soal_image;
      this.showModalPreview = true;
    },
    updateData(row) {
      this.$router.push({
        name: "monitoring-review-jodoh-update",
        params: { id: this.idKompetensi, idsoal: row.idsoal },
      });
    },
    previewImage(url) {
      this.previewUrl = url;
      this.showModalPreview = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <div class="card-title d-flex align-items-center gap-2">
                    Soal Menjodohkan
                    <span
                      class="badge bg-gradient rounded-pill py-1 px-3 fw-bold text-nowrap"
                      :class="statusReviewBadgeClass(kompetensiStatusReview)"
                    >
                      <i
                        :class="statusReviewIcon(kompetensiStatusReview)"
                        class="me-1"
                      ></i>
                      {{ kompetensiStatusReview || "PENDING" }}
                    </span>
                  </div>
                  <div>
                    <span class="font-weight-bold">Kompetensi :</span>
                    <br />
                    <strong>{{ kompetensi?.nama_kompetensi || "-" }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Level Proficiency :</span>
                    <br />
                    <strong>
                      {{ kompetensi?.level_kompetensi?.nama_level || "-" }}
                    </strong>
                  </div>
                </div>
                <div class="d-flex align-items-start gap-2">
                  <router-link
                    class="btn btn-secondary btn-sm"
                    :to="{ name: 'monitoring-review-tools-asesmen' }"
                  >
                    <i class="fa fa-arrow-left me-1"></i>
                    Kembali
                  </router-link>
                  <button
                    v-if="canKirimHasilPerbaikan"
                    class="btn btn-primary btn-sm"
                    @click="kirimHasilPerbaikan()"
                  >
                    <i class="fa fa-paper-plane me-1"></i>
                    Kirim Hasil Perbaikan
                  </button>
                </div>
              </div>
              <div class="col-12">
                <hr />
                <div class="row mb-2">
                  <div class="form-group col-md-3">
                    <label for="filterStatusReview">Status Review</label>
                    <select
                      class="form-select"
                      id="filterStatusReview"
                      v-model="tableFilter.status_review"
                      @change="getData()"
                    >
                      <option value="">SEMUA STATUS</option>
                      <option value="REVISION">REVISION</option>
                      <option value="REVIEWED">REVIEWED</option>
                      <option value="REPAIRED">REPAIRED</option>
                      <option value="COMPLETED">COMPLETED</option>
                    </select>
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <div class="d-flex align-items-end">
                <table>
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <div style="max-width: 50%; width: 500px">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="searchTable"
                  placeholder="Cari Data ..."
                  v-model="tableFilter.search"
                  @input="getData()"
                />
              </div>
            </div>
            <div class="row">
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="isLoading">
                    <td class="text-center" colspan="99">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="table_data == ''">
                    <td class="text-center" colspan="99">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr v-else v-for="(row, key) in table_data" :key="key">
                    <td>
                      <span v-if="key + 1 == 10">
                        {{ currentTablePage }}0.
                      </span>
                      <span v-else>
                        {{
                          currentTablePage - 1 != 0 ? currentTablePage - 1 : ""
                        }}{{ key + 1 }}.
                      </span>
                    </td>
                    <td>{{ row.soal_text || "-" }}</td>
                    <td>{{ row.versi_soal || "-" }}</td>
                    <td>{{ row.tipe || "-" }}</td>
                    <td>
                      <div class="container-image" v-if="row.soal_image">
                        <img
                          v-if="row.soal_image"
                          :src="link + row.soal_image"
                          class="image"
                        />
                        <div
                          class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                        >
                          <button
                            class="btn btn-success btn-sm"
                            @click="previewImage(link + row.soal_image)"
                          >
                            <i class="fa fa-search"></i> Preview
                          </button>
                        </div>
                      </div>
                    </td>
                    <td>
                      {{ row.pertanyaan }}
                    </td>
                    <td>{{ row.jawaban_count || "-" }}</td>
                    <td class="text-center">
                      <span
                        class="badge bg-gradient rounded-pill py-2 px-4 fw-bold text-nowrap w-100"
                        :class="statusReviewBadgeClass(row.status_review)"
                      >
                        <i :class="statusReviewIcon(row.status_review)" class="me-1"></i>
                        {{ row.status_review || "PENDING" }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="d-inline-block text-truncate"
                        style="max-width: 220px"
                        :title="row.catatan_review"
                      >
                        {{ row.catatan_review || "-" }}
                      </span>
                    </td>
                    <td>
                      <div
                        class="d-flex flex-column gap-2"
                        v-if="isWriteSetup || isWriteSetup == 1"
                      >
                        <button
                          class="btn btn-success btn-sm w-100 text-nowrap"
                          @click="preview(row)"
                        >
                          <i class="fa fa-eye me-1"></i>
                          Preview
                        </button>
                        <button
                          class="btn btn-primary btn-sm w-100 text-nowrap"
                          @click="updateData(row)"
                        >
                          <i class="fa fa-wrench me-1"></i>
                          Setup
                        </button>
                        <button
                          v-if="row.has_perbaikan"
                          class="btn btn-outline-secondary btn-sm w-100 text-nowrap"
                          @click="showSoalOriginal(row)"
                        >
                          <i class="fa fa-history me-1"></i>
                          Soal Original
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
            </div>

            <pagination :pagination="pagination" @to-page="toPage"></pagination>

            <hr class="five-dashes" />
            <div class="mt-2 d-flex flex-column align-items-end">
              <table class="table table-borderless mb-0 w-auto align-middle">
                <thead>
                  <tr>
                    <th colspan="3" class="text-end fw-bold p-2">
                      Keterangan Status
                      <i class="fas fa-info-circle text-primary ms-1"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini belum direview</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-secondary py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-clock me-1"></i> PENDING
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini ditandai perlu revisi, menunggu diperbaiki di Monitoring Review</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-danger py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-pen me-1"></i> REVISION
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini sudah dikirim ke Monitoring Review untuk diperbaiki</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-info py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-eye me-1"></i> REVIEWED
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini sudah diperbaiki di Monitoring Review</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-primary py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-wrench me-1"></i> REPAIRED
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="px-2 text-muted text-end">Soal ini sudah di-approve dan dinyatakan selesai</td>
                    <td class="px-2">:</td>
                    <td class="px-2 py-1">
                      <span class="badge rounded-pill bg-gradient bg-success py-2 px-3 fw-bold text-nowrap">
                        <i class="fa fa-check-circle me-1"></i> COMPLETED
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>

  <b-modal
    v-model="showModalPreview"
    title="Preview Gambar"
    centered
    hide-footer
    size="xl"
  >
    <div class="text-center" style="position: relative; width: 100%">
      <img :src="previewUrl" class="image" />
    </div>
  </b-modal>

  <b-modal v-model="modalPreview" title="Preview Soal" size="xl" hide-footer>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-8">
            <table class="table table-bordered">
              <thead class="bg-dark text-white">
                <tr>
                  <th width="50px">No</th>
                  <th>Pertanyaan</th>
                  <th width="80px">No Urut</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ "1" }}</td>
                  <td>
                    {{ dataPreview.pertanyaan }}
                  </td>
                  <td>{{ dataPreview.nomor_urut }}</td>
                </tr>
              </tbody>
            </table>
            <div
              class="container-image-soal"
              v-if="dataPreview.soal_image"
            >
              <img
                v-if="dataPreview.soal_image"
                :src="link + dataPreview.soal_image"
                class="image"
              />
            </div>
          </div>
          <div class="col-4">
            <ul class="list-group list-group-sm">
              <li
                class="list-group-item bg-dark text-white"
                aria-current="true"
              >
                Jawaban
              </li>
              <li
                class="list-group-item"
                v-for="jawaban in dataPreview.jawaban"
                :key="jawaban.idjawaban"
              >
                <div
                  class="container-image-soal pilihan-jawaban"
                  v-html="jawaban.jawaban"
                ></div>
                <span class="float-end text-success" v-if="jawaban.skor > 0">
                  <i class="fa fa-check"></i>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </b-modal>

  <b-modal
    v-model="showModalOriginal"
    title="Soal Original"
    centered
    hide-footer
    size="lg"
  >
    <div v-if="isLoadingSoalOriginal" class="text-center py-5">
      <i class="fas fa-spinner fa-spin font-size-24"></i>
      <div class="mt-2">Mohon tunggu...</div>
    </div>
    <div v-else-if="soalOriginal">
      <div class="mb-2">
        <label class="form-label fw-semibold">Pertanyaan</label>
        <div
          class="form-control"
          style="min-height: 100px; height: auto"
          v-html="soalOriginal.pertanyaan"
        ></div>
      </div>

      <div class="container-image mb-3" v-if="soalOriginal.soal_image">
        <img :src="link + soalOriginal.soal_image" class="image" />
        <div
          class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
        >
          <button class="btn btn-success btn-sm" @click="previewOriginalImage">
            <i class="fa fa-search"></i> Preview
          </button>
        </div>
      </div>

      <table class="table table-striped table-condensed mb-0">
        <thead class="text-center bg-dark text-white">
          <tr>
            <th width="60px">Pilihan</th>
            <th>Jawaban</th>
            <th width="80px">Kunci</th>
          </tr>
        </thead>
        <tbody class="text-center">
          <tr
            v-for="(opsi, index) in soalOriginal.jawaban"
            :key="opsi.kode_jawaban"
          >
            <td class="align-middle">{{ opsi.kode_jawaban || index + 1 }}</td>
            <td>{{ opsi.jawaban || "-" }}</td>
            <td class="align-middle">
              <i
                v-if="opsi.kode_jawaban === soalOriginalKunciJawaban"
                class="fa fa-check-square text-success font-size-18"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<style scoped>
input.largerCheckbox {
  width: 20px;
  height: 20px;
}
</style>
